webpackJsonp([585],{

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2012:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1058),
  /* template */
  __webpack_require__(2436),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/components_dialog-3.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] components_dialog-3.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-013faf9f", Component.options)
  } else {
    hotAPI.reload("data-v-013faf9f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2436:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("dialog")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Actionsheet_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/actionsheet/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/actionsheet"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/actionsheet",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Actionsheet.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Actionsheet } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing the component; use v-model for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-cancel")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing the cancel menu; invalid for android theme")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("cancel(取消)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of cancel menu")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("theme")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ios")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("theme of menus, can be in [‘ios’, ‘android’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("menus")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")]), _c('br'), _c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("{}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("menu items, for example: "), _c('code', [_vm._v("{menu1: 'some text'}")]), _vm._v(", menu name with "), _c('code', [_vm._v(".noop")]), _vm._v(" will not trigger click events. "), _c('br'), _c('code', [_vm._v("Menus")]), _vm._v(" supports array since "), _c('code', [_vm._v("v2.1.0")]), _vm._v(". Keys can be customized. More details below.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("close-on-clicking-mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.0.0")])]), _vm._v(" "), _c('td', [_vm._v("if closing actionsheet when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("close-on-clicking-menu")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('td', [_vm._v("if hide automatically when clicking on menus")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-menu")])]), _vm._v(" "), _c('td', [_vm._v("(menuKey, menuItem)")]), _vm._v(" "), _c('td', [_vm._v("triggers when clicking on the menu")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-menu-{menuKey}")])]), _vm._v(" "), _c('td', [_vm._v("(menuKey)")]), _vm._v(" "), _c('td', [_vm._v("shortcut event for easier listening, "), _c('code', [_vm._v("menuKey")]), _vm._v(" is related to "), _c('code', [_vm._v("label")]), _vm._v(". For exapmple, you can listen on "), _c('code', [_vm._v("on-click-menu-delete")]), _vm._v(" if you have a menu named "), _c('code', [_vm._v("delete")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-menu-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when clicking on the cancel menu")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-mask")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when clicking on mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.4")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/actionsheet"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('p', [_vm._v("From "), _c('code', [_vm._v("v2.1.0")]), _vm._v(", "), _c('code', [_vm._v("menus")]), _vm._v(" supports type: Array.")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("label")]), _vm._v(": label name，you can use simple text or "), _c('code', [_vm._v("html")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("value")]), _vm._v(": event name，if not specified, no "), _c('code', [_vm._v("on-click-menu")]), _vm._v(" will be emitted")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("type")]), _vm._v(":")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("primary")]), _vm._v(" primary color")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("warn")]), _vm._v(" warn color")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("disabled")]), _vm._v(" gray color, the menu cannot be clicked")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("info")]), _vm._v(" the menu item shows as a tip, the same function as "), _c('code', [_vm._v("key.noop")]), _vm._v(" when setting menus by "), _c('code', [_vm._v("Object")]), _vm._v(".")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Are you sure?<br/><span style=\"color:#666;font-size:12px;\">Once deleted, you will never find it.</span>'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'info'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Primary'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'primary'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("value")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'primary'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Warn'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'warn'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Disabled'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'disabled'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Default'")]), _vm._v("\n}]\n")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Alert_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/alert/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/alert"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/alert",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Alert.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Alert } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("This component can be imported as plugin:")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\nWhen importing it as plugin, the usage is different from it in `template`. Please use  `little camel-case`  such as `buttonText` instead of `button-text`.\n")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v("  { AlertPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\nVue.use(AlertPlugin)\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// or the way of umd")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// import built js file")]), _vm._v("\nVue.use(vuxAlertPlugin)\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// show")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.alert.show({\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Vux is Cool'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Do you agree?'")]), _vm._v(",\n  onShow () {\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Plugin: I\\'m showing'")]), _vm._v(")\n  },\n  onHide () {\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Plugin: I\\'m hiding'")]), _vm._v(")\n  }\n})\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// hide")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.alert.hide()\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the component, use v-model for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("alert content, and will be replaced if using slot:default")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("button-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ok(确定)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing dialog when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-fade")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("mask transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-z-index")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("1000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("zIndex of mask")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("dialog content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when dialog shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when dialog is closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/alert"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Confirm_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/confirm/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/confirm"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/confirm",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Confirm.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Confirm } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the component")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-input")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("whether show input or not. If true, slot will not work")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("placeholder of prompt, valid when show-input is true")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("theme")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ios")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog’s style, can be ios or android")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing dialog when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog content, can use html. Invalid when using slot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("confirm-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("确认(confirm)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of confirm button")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("取消(cancel)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of cancel button")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-fade")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("mask’s transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog’s transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("close-on-confirm")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("whether close automatically when confirm button is clicked")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("input-attrs")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.7")])]), _vm._v(" "), _c('td', [_vm._v("input attributes")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-z-index")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("1000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("zIndex of mask")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("body content of the dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when the cancel button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-confirm")])]), _vm._v(" "), _c('td', [_vm._v("(value)")]), _vm._v(" "), _c('td', [_vm._v("triggers when the confirm button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when the dialog shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when the dialog hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("[feature] support prop:mask-z-index")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("setInputValue")])]), _vm._v(" "), _c('td', [_vm._v("(value)")]), _vm._v(" "), _c('td', [_vm._v("set input value when show-input is true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.5")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/confirm"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Loading_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/loading/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/loading"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/loading",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Loading.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Loading } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the component. Use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding before v2.5.7, otherwise use "), _c('code', [_vm._v(":show")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("loading text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("fixed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("position, default is "), _c('code', [_vm._v("fixed")]), _vm._v(", you can use "), _c('code', [_vm._v("absolute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("transition name")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content area")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/loading"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Popup_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popup/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popup",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Popup.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Popup } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of popup, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("auto")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup height, works when position is top or bottom")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing popup when mask being clicked")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-transparent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.9")])]), _vm._v(" "), _c('td', [_vm._v("if using transparent background")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("auto")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("if you want to set 100% width, you should use this prop. only works when position is left or right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("bottom")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("popup position, shoule be one of [‘left’, ‘right’, ‘top’, ‘bottom’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("whether show mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("popup style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-deactivated")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.5")])]), _vm._v(" "), _c('td', [_vm._v("whether hide popup on deactived event when using keep-alive")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content body")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when then popup is closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when the popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-first-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits at the first time the popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Toast_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/toast/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/toast"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/toast",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Toast.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Toast } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing toast, use v-model for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("time")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("2000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("show time")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("success")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("toast type, success, warn, cancel, text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("7.6em")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("toast’s width")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-show-mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing mask, users cannot operate other elements on the page")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("content of the toast, text or html, the same function as default slot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("default")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("toast position, available values: default, top, middle, bottom")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("default slot, the content of the toast")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when toast shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when toast hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/toast"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XDialog_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-dialog/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-dialog"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-dialog",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XDialog.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XDialog } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\nif you use `XDialog` inside `ViewBox` or use `overflowScrolling:touch`，please should import `directive:transfer-dom` to fix `z-index` invalid issue。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\notherwise, you don't need to use `v-transfer-dom`.\n")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { TransferDomDirective "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("as")]), _vm._v(" TransferDom } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("directives")]), _vm._v(": {\n    TransferDom\n  }\n}\n\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-transfer-dom")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-dialog")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-dialog")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the dialog, supports the .sync modifier")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("transition of mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("transition of dialog body")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing dialog when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("[deprecated]if body content can scroll when scrolling on dialog")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])]), _vm._v(" "), _c('td', [_vm._v("set dialog styles, you can use it for overwritting default width and background style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-z-index")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("1000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("zIndex of mask")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("main content of the dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when opening dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when closing dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-dialog"
    }
  }, [_vm._v("Demo page")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-013faf9f", module.exports)
  }
}

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2012);

/***/ })

});


// WEBPACK FOOTER //
// 585.294cdb2c.js